import React, { Component } from 'react';
import GlobalControlLine from './components/GlobalControlLine/GlobalControlLineComponent';
import {QuotaFormContext} from './QuotaContext'
import QuotaMonitorService from "app/services/quotaMonitor.service";
import  GetErrorMessage  from 'app/helpers/error-message'
import {ShowError, ShowSuccess} from "app/components/toast"
import TabQuotas from './components/TabQuotas/TabQuotasComponent';
import ValidateQuota from './QuotaValidation'

class QuotaForm extends Component {    
    constructor(props) {
        super(props);
        this.state = {
            errors: []		
        }
    }    

    SaveQuota(quotas) {        
        this.props.toggleUiBlock(true);        
        QuotaMonitorService.updateQuota(quotas)
            .then(response =>{
                this.props.queryQuotas();  
                this.props.toggleUiBlock(false);
                this.setState({successMessage: 'The quota limit was saved successfully' });              
            })
            .catch(error => {
                let errorMessage = GetErrorMessage(error);
                console.log("errorMessage on catch");
                console.log(errorMessage);
                this.props.toggleUiBlock(false);
                this.setState({ errorMessage: errorMessage});
            });        
    }

    handleSubmitAction = event => { 
		var validationErrors = ValidateQuota(this.props.questionSetQuotas);
		this.setState({errors: validationErrors});
		if (validationErrors && validationErrors.length === 0) {                    
			this.SaveQuota(this.props.questionSetQuotas);
		}        
        return;
    }

    render() {        
        return (
            <div className="AppFormComponent QuotaForm">                 
                <QuotaFormContext.Provider value={
                    {                        
                        queryQuotas: this.props.queryQuotas,                     
                        updateQuestionSetQuotas: this.props.updateQuestionSetQuotas,
                        questionSetQuotas: this.props.questionSetQuotas,
                        questionSetQuotasOriginal: this.props.questionSetQuotasOriginal
                        }}>                
                    <form ref={ form => this.formEl = form } onSubmit={ this.handleSubmitAction }>
                        <div className="form-head">
                            <GlobalControlLine errors={this.state.errors} 
                                handleSubmitAction={this.handleSubmitAction.bind(this)}
								canChangeData={this.props.canChangeData}
								/>                            
                        </div>
                        <div className="form-sections">                            
                                <div className="tab-bar quota-monitor-header">
                                    DQ Quotas Monitor
                                </div>
                                <div className="section-content">                                    
                                    <TabQuotas canChangeData={this.props.canChangeData} metadata={this.props.metadata} errors={this.state.errors} />
                                </div>                            
                        </div>
                    </form>                    
                </QuotaFormContext.Provider>

                {this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}
                {this.state.successMessage && ( <ShowSuccess clearMessage={() => this.setState({successMessage: ''})} message={this.state.successMessage} /> )}                
            </div>            
        );
    }
}
export default QuotaForm; 